var map = {
	"./10258565_489894874523536_7852853142736824577_o.jpg": 7100,
	"./13227645_1086419941415894_8962242256747161177_o-copy.jpg": 1164,
	"./DSC_7219.jpg": 299,
	"./DSC_8124-1-copy.jpg": 2145,
	"./andakulova.png": 3183,
	"./bebold.jpg": 2345,
	"./beograd.jpg": 3641,
	"./collage_mixed_media.jpg": 8721,
	"./design_for_the_senses.jpg": 3995,
	"./express_yourself_in_30x30.jpg": 6418,
	"./images.png": 6985,
	"./maliformat.png": 6021,
	"./mozaik_kao_savremena_umetnost_2017.jpg": 2580,
	"./proart.png": 4407,
	"./qattara.jpg": 9995,
	"./wallofhappiness.jpg": 8597,
	"./whitehorse.jpg": 8493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;